"use client";

import { c as _c } from "react/compiler-runtime";
import Head from "next/head";
import * as Sentry from "@sentry/nextjs";
import { useState, useEffect } from "react";
class SentryExampleFrontendError extends Error {
  constructor(message: string | undefined) {
    super(message);
    this.name = "SentryExampleFrontendError";
  }
}
export default function Page() {
  const $ = _c(22);
  const [hasSentError, setHasSentError] = useState(false);
  const [isConnected, setIsConnected] = useState(true);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const checkConnectivity = async function checkConnectivity() {
        const result = await Sentry.diagnoseSdkConnectivity();
        setIsConnected(result !== "sentry-unreachable");
      };
      checkConnectivity();
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Head><title>sentry-example-page</title><meta name="description" content="Test Sentry for your Next.js app!" /></Head>;
    t3 = <div className="flex-spacer" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg height="40" width="40" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M21.85 2.995a3.698 3.698 0 0 1 1.353 1.354l16.303 28.278a3.703 3.703 0 0 1-1.354 5.053 3.694 3.694 0 0 1-1.848.496h-3.828a31.149 31.149 0 0 0 0-3.09h3.815a.61.61 0 0 0 .537-.917L20.523 5.893a.61.61 0 0 0-1.057 0l-3.739 6.494a28.948 28.948 0 0 1 9.63 10.453 28.988 28.988 0 0 1 3.499 13.78v1.542h-9.852v-1.544a19.106 19.106 0 0 0-2.182-8.85 19.08 19.08 0 0 0-6.032-6.829l-1.85 3.208a15.377 15.377 0 0 1 6.382 12.484v1.542H3.696A3.694 3.694 0 0 1 0 34.473c0-.648.17-1.286.494-1.849l2.33-4.074a8.562 8.562 0 0 1 2.689 1.536L3.158 34.17a.611.611 0 0 0 .538.917h8.448a12.481 12.481 0 0 0-6.037-9.09l-1.344-.772 4.908-8.545 1.344.77a22.16 22.16 0 0 1 7.705 7.444 22.193 22.193 0 0 1 3.316 10.193h3.699a25.892 25.892 0 0 0-3.811-12.033 25.856 25.856 0 0 0-9.046-8.796l-1.344-.772 5.269-9.136a3.698 3.698 0 0 1 3.2-1.849c.648 0 1.285.17 1.847.495Z" fill="currentcolor" /></svg>;
    t5 = <h1>sentry-example-page</h1>;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <a target="_blank" href="https://seize-ff.sentry.io/issues/?project=4510442439573504">Issues Page</a>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <p className="description">Click the button below, and view the sample error on the Sentry {t6}. For more details about setting up Sentry, <a target="_blank" href="https://docs.sentry.io/platforms/javascript/guides/nextjs/">read our docs</a>.</p>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = async () => {
      await Sentry.startSpan({
        name: "Example Frontend/Backend Span",
        op: "test"
      }, async () => {
        const res = await fetch("/api/sentry-example-api");
        if (!res.ok) {
          setHasSentError(true);
        }
      });
      throw new SentryExampleFrontendError("This error is raised on the frontend of the example page.");
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const t9 = !isConnected;
  let t10;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span>Throw Sample Error</span>;
    $[9] = t10;
  } else {
    t10 = $[9];
  }
  let t11;
  if ($[10] !== t9) {
    t11 = <button type="button" onClick={t8} disabled={t9}>{t10}</button>;
    $[10] = t9;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] !== hasSentError || $[13] !== isConnected) {
    t12 = hasSentError ? <p className="success">Error sent to Sentry.</p> : !isConnected ? <div className="connectivity-error"><p>It looks like network requests to Sentry are being blocked, which will prevent errors from being captured. Try disabling your ad-blocker to complete the test.</p></div> : <div className="success_placeholder" />;
    $[12] = hasSentError;
    $[13] = isConnected;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="flex-spacer" />;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== t11 || $[17] !== t12) {
    t14 = <main>{t3}{t4}{t5}{t7}{t11}{t12}{t13}</main>;
    $[16] = t11;
    $[17] = t12;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <style>{"\n        main {\n          display: flex;\n          min-height: 100vh;\n          flex-direction: column;\n          justify-content: center;\n          align-items: center;\n          gap: 16px;\n          padding: 16px;\n          font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", sans-serif;\n        }\n\n        h1 {\n          padding: 0px 4px;\n          border-radius: 4px;\n          background-color: rgba(24, 20, 35, 0.03);\n          font-family: monospace;\n          font-size: 20px;\n          line-height: 1.2;\n        }\n\n        p {\n          margin: 0;\n          font-size: 20px;\n        }\n\n        a {\n          color: #6341F0;\n          text-decoration: underline;\n          cursor: pointer;\n\n          @media (prefers-color-scheme: dark) {\n            color: #B3A1FF;\n          }\n        }\n\n        button {\n          border-radius: 8px;\n          color: white;\n          cursor: pointer;\n          background-color: #553DB8;\n          border: none;\n          padding: 0;\n          margin-top: 4px;\n\n          & > span {\n            display: inline-block;\n            padding: 12px 16px;\n            border-radius: inherit;\n            font-size: 20px;\n            font-weight: bold;\n            line-height: 1;\n            background-color: #7553FF;\n            border: 1px solid #553DB8;\n            transform: translateY(-4px);\n          }\n\n          &:hover > span {\n            transform: translateY(-8px);\n          }\n\n          &:active > span {\n            transform: translateY(0);\n          }\n\n          &:disabled {\n\t            cursor: not-allowed;\n\t            opacity: 0.6;\n\t\n\t            & > span {\n\t              transform: translateY(0);\n\t              border: none\n\t            }\n\t          }\n        }\n\n        .description {\n          text-align: center;\n          color: #6E6C75;\n          max-width: 500px;\n          line-height: 1.5;\n          font-size: 20px;\n\n          @media (prefers-color-scheme: dark) {\n            color: #A49FB5;\n          }\n        }\n\n        .flex-spacer {\n          flex: 1;\n        }\n\n        .success {\n          padding: 12px 16px;\n          border-radius: 8px;\n          font-size: 20px;\n          line-height: 1;\n          background-color: #00F261;\n          border: 1px solid #00BF4D;\n          color: #181423;\n        }\n\n        .success_placeholder {\n          height: 46px;\n        }\n\n        .connectivity-error {\n          padding: 12px 16px;\n          background-color: #E50045;\n          border-radius: 8px;\n          width: 500px;\n          color: #FFFFFF;\n          border: 1px solid #A80033;\n          text-align: center;\n          margin: 0;\n        }\n        \n        .connectivity-error a {\n          color: #FFFFFF;\n          text-decoration: underline;\n        }\n      "}</style>;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t14) {
    t16 = <div>{t2}{t14}{t15}</div>;
    $[20] = t14;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  return t16;
}